<template>
    <div class="flex border-collapse border-b border-gray-200 draggable" :class="backgroundColor()" :key="attendeeKey">
        <div class="w-6 flex-shrink-0">
            <div class="px-2 py-2 w-5 h-5 flex attendees-center">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle" v-if="!readonly"></i>
            </div>
        </div>
        <div class="flex-1 border-l border-r">
            <package-contact-search
                class="flex-1"
                #default="{ open, query, setQuery }"
                @selected:contact="attendeeSelected"
                :top="true"
                :contacts="contacts"
                v-if="!attendee.signature"
            >
                <input
                    placeholder="N‌a‌m‌e..."
                    class="flex-1 text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-20 focus:z-20 resize-none "
                    type="text"
                    ref="name"
                    disabled="readonly"
                    v-model="attendee.name"
                    @input="setQuery($event.target.value);save()"
                    @focus="setQuery($event.target.value);open()"
                />
            </package-contact-search>
            <div class="flex-1 border-gray-200 px-0 py-0 overflow-x-auto relative" v-else>
                <div class="text-sm px-2 py-1">
                    {{ attendee.name ? attendee.name : "&nbsp;" }}
                </div>
            </div>
        </div>
        <div class="flex-1 border-r border-gray-200 px-0 py-0">
            <input
                placeholder="Position..."
                class="flex-1 text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-20 focus:z-20 resize-none "
                type="text"
                disabled="readonly"
                v-model="attendee.position"
                @input="save()"
                v-if="!attendee.signature"
            />
            <div class="flex-1 border-gray-200 px-0 py-0 overflow-x-auto relative" v-else>
                <div class="text-sm px-2 py-1">
                    {{ attendee.position ? attendee.position : "&nbsp;" }}
                </div>
            </div>
        </div>
        <div class="w-20 flex border-r border-gray-200 px-0 py-0 relative">
            <ui-dropdown placement="bottom-start" menu-class="p-3 w-56 flex" class="flex w-full"
                         trigger-class="flex w-full">
                <template #default="{ open, close }">
                    <div @mouseover="open" @mouseleave="close" class="w-full relative flex justify-center"
                         @click="() => { if (!attendee.signature) { addSignature(); }}">
                        <img v-if="attendee.signature" :src="attendee.signature" height="28px" width="100%"
                             class="m-0 p-0 absolute"
                             style="right:0px; top:0px; height:28px; z-index: 20">
                        <div v-else-if="attendee.signatureRequestedAt" class="text-blue-400 mt-0.5">
                            <i style="font-size: 11px" class="fas fa-phone"></i>...
                        </div>
                    </div>
                </template>
                <template #menu>
                    <table class="w-full" v-if="attendee.signatureRequestedAt">
                        <tbody>
                        <tr>
                            <td class="text-gray-600 text-xs">Signature last requested at :</td>
                        </tr>
                        <tr>
                            <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                {{ attendee.signatureRequestedAt }}
                            </td>
                        </tr>
                        <tr>
                            <td class="text-gray-600 text-xs">Signature last requested by:</td>
                        </tr>
                        <tr>
                            <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                {{ attendee.signatureRequestedBy }}
                            </td>
                        </tr>
                        <tr>
                            <td class="text-gray-600 text-xs">Signature last requested using:</td>
                        </tr>
                        <tr>
                            <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                {{ attendee.signatureRequestedTo }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="w-full" v-else>
                        <tbody>
                        <tr>
                            <td class="text-gray-600 text-xs">No Signature request yet sent</td>
                        </tr>
                        </tbody>
                    </table>

                </template>
            </ui-dropdown>
        </div>
        <div class="w-6 flex-shrink-0 ml-2 mt-1">
            <template>
                <ui-dropdown menu-class="p-3 w-56">
                    <template #default="{ toggle }">
                        <button @click="toggle"
                                class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                            <i class="fa fa-ellipsis-h fa-fw"></i>
                        </button>
                    </template>
                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-phone" @click="sendSignatureRequest();close();">
                            Request Signature
                        </ui-dropdown-item>
                        <ui-dropdown-divider></ui-dropdown-divider>
                        <ui-dropdown-item icon="fas fa-pencil" @click="addSignature();close();"
                                          v-if="!attendee.signature">Add Signature
                        </ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-pencil" @click="addSignature();close();" v-else>Re-Sign Signature
                        </ui-dropdown-item>
                        <ui-dropdown-divider v-if="!attendee.signatureRequestedAt"></ui-dropdown-divider>
                        <ui-dropdown-item icon="fas fa-trash" danger @click="deleteAttendee();close();"
                                          v-if="!attendee.signatureRequestedAt">Delete
                        </ui-dropdown-item>

                    </template>
                </ui-dropdown>
            </template>
        </div>
    </div>
</template>

<script>
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import {isNull} from "lodash";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";
import {RAMS} from "@models";

export default {
    components: {
        PackageContactSearch,
        UiDropdownItem, UiDropdown, AutoresizableTextarea
    },
    props: {
        attendee: Object,
        rams: Object,
        contacts: Object,
        readonly: false,
    },
    data() {
        return {
            attendeeKey:0
        }
    },
    methods: {
        deleteAttendee() {
            let i = this.rams.attendees.findIndex((i) => i.id === this.attendee.id)
            this.rams.attendees.splice(i,1)
        },
        addSignature() {
            this.$modals.sign({
                title: `Sign as "${this.attendee.name}"`,
                button: 'Confirmed',
                handle: (data) => {
                    this.rams.attendees.find((i) => i.id === this.attendee.id).signature = data.signature;
                    this.rams.update();
                    let attendee = this.rams.attendees.find((i) => i.id === this.attendee.id);
                    if (attendee) {
                            Object.assign(this.attendee, attendee)
                        }
                    this.attendeeKey++;
                }
            })
        },
        sendSignatureRequest() {
            this.$modals.open('rams-signature-request', {
                title: `Send signature request to "${this.attendee.name}"`,
                contacts: this.contacts,
                name: this.attendee.name,
                handle: async (data, modal) => {
                    let attendee = this.rams.attendees.find((i) => i.id === this.attendee.id);
                    if (attendee) {
                        await this.rams.requestSignature(attendee.id, data.to).then(async () => {
                            let attendee = this.rams.attendees.find((i) => i.id === this.attendee.id);
                            if (attendee) {
                                Object.assign(this.attendee, attendee)
                            }
                            modal.close()
                            this.attendeeKey++;
                        })
                    }
                }
            })
        },
        backgroundColor() {
            if (this.attendee.signature) {
                return 'bg-green-50';
            }
            return 'bg-white';
        },
        isNull,
        getHeight(el) {
            let max = 0;
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                area.setAttribute('style', 'height:auto')
            }
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                max = Math.max(max, area.scrollHeight);
            }
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                area.setAttribute('style', 'height:' + max + 'px;overflow-y:hidden;')
            }
            if (this.focussed) {
                this.focussed.open();
            }
            return max + 'px';
        },
        removeAttendee() {
            let paragraph = [];
            if (this.attendee.signature) {
                paragraph.push('Warning - This person has already signed this register!');
            }
            paragraph.push('This action is irreversible. Are you sure you want to proceed?');
            this.$modals.confirmDelete({
                title: `Delete "${this.attendee.name}"`,
                button: 'Yes, delete this person',
                paragraphs: paragraph,
                handle: async () => {
                    this.$emit('removeAttendee', this.attendee)
                }
            })
        },
        save() {
            this.$emit('updatedAttendee', this.attendee)
        },
        attendeeSelected(e) {
            this.attendee.name = e.name
            this.save();
            this.$nextTick(() => {
                this.getHeight(this.$refs.name);
            })
        },
    },
}
</script>
